import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAuth } from "hooks";
import Card from "components/Card";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import AccountValue from "./AccountValue";
import NameChangeModal from "./NameChangeModal";

/**
 * AccountName
 *
 * Shows the signed-in user's full name and lets them change it.
 */
const AccountName = () => {
  const { id, firstName, lastName, fullName } = useAuth();
  const [showModal, setShowModal] = useState(false);

  return (
    <Card>
      <Header noUnderline>
        <H3>
          <FormattedMessage id="UserSettings.Account.Name.Title" />
        </H3>
      </Header>

      <AccountValue onChange={() => setShowModal(true)}>{fullName}</AccountValue>

      <NameChangeModal
        updateId={id}
        firstName={firstName}
        lastName={lastName}
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </Card>
  );
};

export default AccountName;
